import styled from 'styled-components'

export const Suffix = styled.span`
  color: var(--text-pro);
`
